import { render, staticRenderFns } from "./privacyCancel.vue?vue&type=template&id=83c48ee0&"
import script from "./privacyCancel.vue?vue&type=script&lang=js&"
export * from "./privacyCancel.vue?vue&type=script&lang=js&"
import style0 from "./privacyCancel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports